import GitHubIcon from "@mui/icons-material/GitHub";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Mail";
import XIcon from "@mui/icons-material/X";

export const personalDetails = {
    name: "Ankit Barik",
    dep: "Designing Scalable Backend Systems",
    ability:
        "Currently building production-grade backend systems with a focus on system design, microservices architecture, distributed services, and scalable APIs. Proficient in Node.js, Express, MongoDB, and message-driven architecture.",
    socialLinks: [
        {
            name: "github",
            link: "https://github.com/ankitkumarbarik",
            icon: <GitHubIcon sx={{ fontSize: 24 }} />,
        },
        {
            name: "linkedin",
            link: "https://www.linkedin.com/in/ankitkumarbarik/",
            icon: <LinkedInIcon sx={{ fontSize: 24 }} />,
        },
        {
            name: "x",
            link: "https://x.com/ankitbarik_dev",
            icon: <XIcon sx={{ fontSize: 24 }} />,
        },
        {
            name: "mail",
            link: "mailto:ankitbarik.dev@gmail.com",
            icon: <MailIcon sx={{ fontSize: 24 }} />,
        },
        {
            name: "instagram",
            link: "https://pastebin.com/Jmn57s6W",
            icon: <InstagramIcon sx={{ fontSize: 24 }} />,
        },
    ],
};
